import React, {useState,useEffect} from "react";
import {StyledLinkButton, StyledPurchaseDetails, StyledTitle, StyledTwoBoxWrapper} from "../style/global.style";
import {CancelLeft, CancelLeftInner, CancelRight, StyledCancelPlan, StyledCardPrice} from "./plans.style";
import {useHistory, useParams} from "react-router-dom";
import plansList from "./plansList";
import {Terms} from "../checkout/checkout.style";
import LinkButton from "../linkButton/LinkButton.component";
import Recommendation from "../commons/recommendation/recommendation.compoenent";

const CancelPlan = () => {
    const { planId } = useParams();
    const [plan,setPlan] = useState({});
    const history = useHistory();

    useEffect(()=> {
        const [planObj] = plansList.filter((plan)=> {
            return plan.arrayId === planId
        })
        setPlan(planObj);
    },[planId])

    return (
        <StyledCancelPlan>
            <StyledTwoBoxWrapper className={"mt-1"}>
                <CancelLeft>
                    <CancelLeftInner>
                        <StyledTitle>
                            Oh boy, I didn’t see this coming.
                        </StyledTitle>
                        Cancelling your plan will disable your
                        Fixel installation.
                        <br/>
                        <br/>
                            The existing audiences in your ad<br/>
                            platforms will persist and will still be<br/>
                            available for your campaign.<br/>
                            However, since they won't be updated, their<br/>
                            performance is expected to deteriorate over time.<br/>
                        <LinkButton className={"mt-2"} alert={true} to={ {pathname:`/plans/cancel/${plan.name}/confirmation`,plan: plan} }>
                            Cancel Plan
                        </LinkButton>
                    </CancelLeftInner>
                    <StyledLinkButton style={ {transform: 'translateY(45px)', position: 'absolute'} } onClick={ () => history.goBack() }>Go back</StyledLinkButton>
                </CancelLeft>
                <CancelRight>
                    <StyledPurchaseDetails>
                        <h4>{plan.name}</h4>
                        <StyledCardPrice>
                            <span>{plan.price}$</span>
                            <p>/month</p>
                        </StyledCardPrice>
                        <Terms>
                            {plan.terms}
                        </Terms>
                    </StyledPurchaseDetails>
                </CancelRight>
            </StyledTwoBoxWrapper>
            <Recommendation className={"mt-1"} theme={'full'}/>
        </StyledCancelPlan>
    )
};
export default React.memo(CancelPlan);